"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _axios = _interopRequireDefault(require("axios"));

var _Response = _interopRequireDefault(require("./Response"));

var _qs = _interopRequireDefault(require("qs"));

var _Cache = _interopRequireDefault(require("../Tools/Cache"));

var _EnvironmentVariables = _interopRequireDefault(require("../Tools/EnvironmentVariables"));

var _Exception = require("../Exceptions/Exception");

var _ExceptionCode = require("../Exceptions/ExceptionCode");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

_axios.default.interceptors.request.use(config => {
  config.paramsSerializer = params => {
    // Qs is already included in the Axios package
    return _qs.default.stringify(params, {
      arrayFormat: "brackets",
      encode: true
    });
  };

  return config;
});

const cache = new _Cache.default(86400); // 24 Hora

class Request {
  static async request(data) {
    if (!Request.httpClient) {
      Request.httpClient = _axios.default;
    }

    let serviceAddress = await Request.loadServiceAddress(data.service || 'storage', data.version || 'v1');
    let endpoint = data.endpoint || '/';
    let headers = data['headers'] || { ...Request.generalHeaders
    };

    if (data.pagination) {
      if (data.pagination.page) {
        headers['x-pagination-index'] = data.pagination.page;
      }

      if (data.pagination.limit) {
        headers['x-pagination-limit'] = data.pagination.limit;
      }

      if (data.pagination.order) {
        headers['x-pagination-order'] = data.pagination.order;
      }

      if (data.pagination.direction) {
        headers['x-pagination-direction'] = data.pagination.direction;
      }

      if (data.pagination.disabled) {
        headers['x-pagination-disabled'] = data.pagination.disabled;
      }
    }

    data = Object.assign({
      crossdomain: true,
      url: `${serviceAddress}${endpoint}`,
      headers
    }, data);
    return Request.httpClient(data).then(response => {
      var _response$data;

      let result = response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.response;
      return new _Response.default((result === null || result === void 0 ? void 0 : result.data) || null, (result === null || result === void 0 ? void 0 : result.code) || 200, (result === null || result === void 0 ? void 0 : result.errors) || [], (result === null || result === void 0 ? void 0 : result.pagination) || null);
    });
  }

  static get(data) {
    data['method'] = 'get';
    return this.request(data);
  }

  static put(data) {
    data['method'] = 'put';
    return this.request(data);
  }

  static post(data) {
    data['method'] = 'post';
    return this.request(data);
  }

  static patch(data) {
    data['method'] = 'patch';
    return this.request(data);
  }

  static delete(data) {
    data['method'] = 'delete';
    return this.request(data);
  }

  static setHeader(header, value) {
    this.generalHeaders[header] = value;
  }

  static setHeaders(headersArray = []) {
    Object.keys(headersArray).map(key => {
      this.setHeader(key, headersArray[key]);
    });
  }

  static loadServiceAddress(serviceName, version) {
    let servicesEndpoint = null;
    let stage = null;

    if (process.env.VUE_APP_SERVICES_ENDPOINT_BASE) {
      servicesEndpoint = process.env.VUE_APP_SERVICES_ENDPOINT_BASE;
    } else if (process.env.REACT_APP_SERVICES_ENDPOINT_BASE) {
      servicesEndpoint = process.env.REACT_APP_SERVICES_ENDPOINT_BASE;
    } else if (process.env.ECS_SERVICES_ENDPOINT_BASE) {
      servicesEndpoint = process.env.ECS_SERVICES_ENDPOINT_BASE;
    } else if (_EnvironmentVariables.default.SERVICES_ENDPOINT_BASE) {
      servicesEndpoint = _EnvironmentVariables.default.SERVICES_ENDPOINT_BASE;
    }

    if (process.env.VUE_APP_STAGE) {
      stage = process.env.VUE_APP_STAGE;
    } else if (process.env.REACT_APP_STAGE) {
      stage = process.env.REACT_APP_STAGE;
    } else if (process.env.STAGE) {
      stage = process.env.STAGE;
    }

    if (servicesEndpoint) {
      return `${servicesEndpoint.replace('{SERVICE}', serviceName).replace('{STAGE}', stage).toLowerCase()}/${version.toLowerCase()}`;
    } else {
      throw new _Exception.Exception(_ExceptionCode.ExceptionCode.ENVIRONMENT_ENDPOINT_UNDEFINED);
    }
  }

}

exports.default = Request;

_defineProperty(Request, "httpClient", null);

_defineProperty(Request, "generalHeaders", []);